import { render, staticRenderFns } from "./LoyaltyAccounts.vue?vue&type=template&id=97731a04&scoped=true"
import script from "./LoyaltyAccounts.vue?vue&type=script&lang=js"
export * from "./LoyaltyAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97731a04",
  null
  
)

export default component.exports